//  ------------------- Common Routes ---------------------
export const HOME = "/";

// Colors
export const COLORS = "/settings/color";

// Sizes
export const SIZES = "/settings/size";

// Size chart master
export const SIZE_CHARTS = "/settings/size-chart";

// Categories
export const CATEGORIES = "/settings/category";

// platforms
export const PLATFORMS = "/settings/platform";

// expenseType
export const EXPENSE_TYPE = "/settings/expense-type";

// incomeType
export const INCOME_TYPE = "/settings/income-type";

// Fabrics
export const FABRICS = "/settings/fabric";

// inventory
export const INVENTORY_MANAGEMENT = "/inventory-management";

export const PURCHASE_ORDERS = "/purchase-orders";
export const PURCHASE_ORDERS_ADD = "/purchase-orders/add";
export const PURCHASE_ORDERS_EDIT = "/purchase-orders/edit/:id";
export const purchaseOrderEdit = (id) => `/purchase-orders/edit/${id}`;

export const BILL_LIST = "/bill";
export const BILL_VIEW = "/bill/view/:viewId";
export const billView = (viewId) => `/bill/view/${viewId}`;
export const BILL_ADD_From_PO = "/bill/add/:poId";
export const BILL_ADD = "/bill/add";
export const BILL_EDIT = "/bill/edit/:id";
export const billEdit = (id) => `/bill/edit/${id}`;

export const DEBIT_NOTE = "/bill/debit-note/:id";
export const debitNote = (id) => `/bill/debit-note/${id}`;

export const DEBIT_NOTE_LIST = "/bill/debit-note-list/:id";
export const debitNoteList = (id) => `/bill/debit-note-list/${id}`;

export const billAddFromPO = (poId) => `/bill/add/${poId}`;

export const SALES_INVOICE = "/invoice";
export const SALES_INVOICE_ADD = "/invoice/add";
export const SALES_INVOICE_EDIT = "/invoice/edit/:id";
export const salesInvoiceEdit = (id) => `/invoice/edit/${id}`;

// Users
export const USERS = "/settings/users";
export const USERS_ADD = "/settings/user/add";
export const USERS_EDIT = "/settings/user/edit/:id";
export const userEditById = (id) => `/settings/user/edit/${id}`;
export const USERS_ATTENDANCE_LOG = "/settings/user/attendance-log/:id";
export const userAttendanceLogById = (id) =>
  `/settings/user/attendance-log/${id}`;

// Roles & Permissions
export const ROLES = "/settings/roles";
export const MANAGE_PERMISSION = "/settings/manage-permission/:id";
export const managePermission = (id) => `/settings/manage-permission/${id}`;

// Vendors
export const VENDORS = "/vendor";

// Meesho
export const MEESHO = "/meesho";
export const MEESHO_DASHBOARD = "/meesho/dashboard";
export const MEESHO_BULK_IMPORT = "/meesho/orders-import";
export const MEESHO_PAYMENT_IMPORT = "/meesho/payment-import";
export const MEESHO_ORDERS_LIST = "/meesho/invoices-list";
export const MEESHO_RTO = "/meesho/rto";
export const MEESHO_PAYMENT = "/meesho/payment";
export const MEESHO_REPORT = "/meesho/report";

//  ------------------- Office Routes ---------------------

// Products
export const PRODUCTS = "/product-manager/products";
export const PRODUCT_ADD = "/product-manager/product/add";
export const PRODUCT_EDIT = "/product-manager/product/edit/:id";
export const productEdit = (id) => `/product-manager/product/edit/${id}`;
export const PRODUCT_VARIANTS = "/product-manager/product/variant/:productId";
export const officeProductVariant = (productId) =>
  `/product-manager/product/variant/${productId}`;

// Product Variants
export const PRODUCT_VARIANT_ADD =
  "/office/product-manager/product-variant/add";
export const PRODUCT_VARIANT_EDIT =
  "/office/product-manager/product-variant/edit/:id";

// Logs
export const LOGS_URL = "/logs";

// entry book
export const CASH_BOOK = "/cash-book";
export const CHEQUE_BOOK = "/cheque-book";
export const createCashChequeCreditDebitRoute = (id, type) =>
  `${id}?type=${type}`;
export const CASH_CREDIT_DEBIT = "/cash";
export const CASH = "/cash";
export const CHEQUE_CREDIT_DEBIT = "/cheque";
export const CHEQUE = "/cheque";

export const LEDGER = "/ledger";

export const PROFIT_LOSS = "/profit-loss";
export const BALANCE_SHEET = "/balance-sheet";
export const OUTSTANDING_REPORT = "/payment-report";

// Sample Management
export const SAMPLES = "/samples";
export const SAMPLES_ADD = "/samples/add";
export const SAMPLES_EDIT = "/samples/edit/:id";
export const sampleEditById = (id) => `/samples/edit/${id}`;
export const SAMPLES_RETURN = "/samples/return/:id";
export const sampleReturnById = (id) => `/samples/return/${id}`;
export const SAMPLES_RETURN_LIST = "/samples/return-list/:id";
export const sampleReturnList = (id) => `/samples/return-list/${id}`;

// Audit
export const AUDITS = "/audit";
export const AUDITS_ADD = "/audit/add";
export const AUDITS_EDIT = "/audit/edit/:id";
export const auditEditById = (id) => `/audit/edit/${id}`;
export const AUDITS_LIST = "/audit/list/:id";
export const auditList = (id) => `/audit/list/${id}`;

// Order Management
export const ORDER_MANAGEMENT = "/order-management";
export const ORDER_MANAGEMENT_IMPORT = "/order-management/import";
export const ORDER_MANAGEMENT_ORDER_HISTORY = "/order-management/order-history";
export const ORDER_MANAGEMENT_PAYMENT_MARKETING_EXPENSES_HISTORY =
  "/order-management/payment-marketing-expenses-history";
export const ORDER_MANAGEMENT_LIST = "/order-management/orders";
export const ORDER_MANAGEMENT_STATISTICS = "/order-management/statistics";
export const ORDER_MANAGEMENT_STATISTICS_LIST =
  "/order-management/statistics/list/:status";
export const orderManagementStatisticsList = (status) =>
  `/order-management/statistics/list/${status}`;
export const ORDER_MANAGEMENT_RETURNS = "/order-management/returns";
export const ORDER_MANAGEMENT_RETURN_PROCESS =
  "/order-management/return-process";
export const ORDER_MANAGEMENT_PAYMENT_PROCESS =
  "/order-management/payment-process";
export const ORDER_MANAGEMENT_MARKETING_EXPENSES =
  "/order-management/marketing-expenses";
export const ORDER_MANAGEMENT_FINANCE_DASHBOARD =
  "/order-management/finance-dashboard";
export const ORDER_MANAGEMENT_PAYOUT_BREAKDOWN =
  "/order-management/payout-breakdown";
export const ORDER_MANAGEMENT_PRODUCT_REPORT =
  "/order-management/product-report";

// Flipkart
export const FLIPKART = "/flipkart";
export const FLIPKART_IMPORT = "/flipkart/import";
export const FLIPKART_ORDER_HISTORY = "/flipkart/import-history";
export const FLIPKART_ORDERS_LIST = "/flipkart/orders";
export const FLIPKART_PAYMENTS = "/flipkart/payments";
export const FLIPKART_PRODUCT_REPORT = "/flipkart/product-report";
export const FLIPKART_STATISTICS = "/flipkart/statistics";
export const FLIPKART_STATISTICS_LIST = "/flipkart/statistics/list/:status";
export const flipkartStatisticsList = (status) =>
  `/flipkart/statistics/list/${status}`;
export const FLIPKART_FINANCE_DASHBOARD = "/flipkart/finance-dashboard";
export const UNIT_ECONOMICS = "/unit-economic-calculator";
export const APP_SALES_REPORT = "/app-sales-report";

// Order label PDF import
export const ORDER_LABEL_IMPORT = "/order-label-import";

// Myntra
export const MYNTRA = "/myntra";
export const MYNTRA_IMPORT = "/myntra/import";
export const MYNTRA_ORDER_HISTORY = "/myntra/import-history";
export const MYNTRA_ORDERS_LIST = "/myntra/orders";
export const MYNTRA_RETURNS = "/myntra/returns";
export const MYNTRA_PAYMENTS = "/myntra/payments";
export const MYNTRA_PRODUCT_REPORT = "/myntra/product-report";
export const MYNTRA_STATISTICS = "/myntra/statistics";
export const MYNTRA_STATISTICS_LIST = "/myntra/statistics/list/:status";
export const myntraStatisticsList = (status) =>
  `/myntra/statistics/list/${status}`;
export const MYNTRA_FINANCE_DASHBOARD = "/myntra/finance-dashboard";
export const MYNTRA_MARKETING_EXPENSES = "/myntra/marketing-expenses";
export const MYNTRA_RETURN_REASON_ANALYSIS = "/myntra/return-reason-analysis";
export const ORDER_MANAGEMENT_RETURN_REASON_ANALYSIS = "/order-management/return-reason-analysis";
// attendance
export const ATTENDANCE_QR = "/attendance-qr";
